// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmp3LLlndM7B6fV-sn3J84Gh8c1_lnZSc",
  authDomain: "mildmisaki-gl-db.firebaseapp.com",
  projectId: "mildmisaki-gl-db",
  storageBucket: "mildmisaki-gl-db.firebasestorage.app",
  messagingSenderId: "619413965806",
  appId: "1:619413965806:web:efd457b4741d27af15dcff",
  measurementId: "G-2X0EYNJFLT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
